import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
    Row,
    Card,
    CardTitle,
    Form,
    Label,
    Input,
    Button,
    FormText,
    FormGroup,
} from 'reactstrap';
import { connect } from 'react-redux';
import { registerUser } from '../../redux/actions';
import { Colxx } from '../../components/common/CustomBootstrap';
// import Validator from '../../constants/validatorForm';
import IntlMessages from '../../helpers/IntlMessages';
import {
    NotificatioErrController,
    NotificatioSucController,
} from '../../helpers/Utils';
import { END_POINT } from '../../constants/defaultValues';
import axios from 'axios';
import { Validator } from '../../helpers/Validator';

const Register = (props) => {
    const [values, setValues] = useState({
        fullname: '',
        phone: '',
        email: '',
        password: '',
        domain: '',
        url: window.location.host.replace('register.', ''),
        popover: false,
        pinSuccessMessage: false,
    });

    // THÊM STATE MỚI ĐỂ KIỂM TRA TÍNH DUY NHẤT CỦA DOMAIN
    const [domainAvailability, setDomainAvailability] = useState({
        status: 'idle', // 'idle', 'checking', 'available', 'taken', 'error'
        message: '',
    });

    useEffect(() => {
        const initializeValidators = () => {
            Validator({
            form: '#form-register',
            formGroupSelector: '.form-group',
            errorSelector: '.form-message',
            rules: [
                Validator.isRequired('#fullname'),
                Validator.isRequired('#phone'),
                Validator.minLength('#phone', 10),
                Validator.maxLength('#phone', 10),
                Validator.isRequired('#email'),
                Validator.isEmail('#email'),
                Validator.isRequired('#domain'),
                Validator.isCharacter('#domain'),
                {
                selector: '#domain',
                test: (value) => {
                    // Chỉ báo lỗi nếu đã kiểm tra và domain 'taken'
                    if (domainAvailability.status === 'taken') {
                        return domainAvailability.message || 'Tên miền này đã được sử dụng.';
                    }
                    // Nếu đang check, có thể tạm thời không báo lỗi hoặc báo "đang kiểm tra"
                    // if (domainAvailability.status === 'checking') {
                    //     return 'Đang kiểm tra tên miền...';
                    // }
                    return undefined; // Không có lỗi
                }
              },
                Validator.isRequired('#password'),
                Validator.minLength('#password', 6),
            ],
            onSubmit: (data) => {
                // Call API
                console.log(data);
            },
            });
        };
        initializeValidators();
        // Cleanup function if needed
        return () => {
            // Any cleanup code here
        };
    }, [domainAvailability.status, domainAvailability.message, values]);

    // HÀM GỌI API KIỂM TRA TÍNH DUY NHẤT (PUBLIC)
    const checkDomainUniqueness = async (domain) => {
        if (!domain || domain.trim() === '') {
            setDomainAvailability({ status: 'idle', message: '' });
            return;
        }

        // Kiểm tra định dạng cơ bản trước khi gọi API
        const rgxStore = /^[a-z0-9_]+$/;
        if (!rgxStore.test(domain)) {
            // Không cần setDomainAvailability ở đây vì Validator.isCharacter sẽ xử lý
            // Hoặc có thể set một trạng thái lỗi định dạng riêng nếu muốn
            return;
        }

        setDomainAvailability({ status: 'checking', message: 'Đang kiểm tra...' });

        try {
            const response = await axios.get(`${END_POINT}/user/check-domain-availability?domain=${domain.toLowerCase()}`);
            if (response.data.isAvailable) {
                setDomainAvailability({ status: 'available', message: response.data.message || 'Tên miền có thể sử dụng!' });
            } else {
                setDomainAvailability({ status: 'taken', message: response.data.message || 'Tên miền đã được sử dụng.' });
            }
        } catch (err) {
            console.error("Lỗi khi kiểm tra domain:", err.response || err.message);
            const errorMessage = err.response?.data?.message || 'Lỗi khi kiểm tra tên miền. Vui lòng thử lại.';
            setDomainAvailability({ status: 'error', message: errorMessage });
        }
    };

    
    const useDebouncedFunction = (fn, delay) => {
        const timeoutRef = useRef(null);

        const debouncedFn = useCallback((...args) => {
            if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
            fn(...args);
            }, delay);
        }, [fn, delay]);

        return debouncedFn;
    };
    
    const debouncedCheckDomainUniqueness = useDebouncedFunction(checkDomainUniqueness, 500);

    const onUserRegister = () => {
        if (
            values.fullname !== '' &&
            values.phone !== '' &&
            values.email !== '' &&
            values.password !== '' &&
            values.domain !== ''
        ) {
            props.registerUser(values, props.history);
        } else {
            NotificatioErrController('Vui lòng nhập đầy đủ các thông tin');
            return false;
        }
    };

    const onChangeHandleInput = (e) => {
        const { value, name } = e.target;
        setValues({ ...values, [name]: value });
        
        if (name === 'domain') {
            checkDomainConditions(value);
            debouncedCheckDomainUniqueness(value);
        }
    };

    // THÊM STATE MỚI ĐỂ THEO DÕI CÁC ĐIỀU KIỆN CỦA DOMAIN
    const [domainConditions, setDomainConditions] = useState({
        noSpaces: false,
        isShopNameLike: false, // "Là tên cửa hàng của bạn" - điều kiện này hơi mơ hồ, tạm coi là >0 ký tự
        onlyLowercaseAndNumbers: false,
        // isUnique: false, // Điều kiện này cần check API, sẽ phức tạp hơn
    });

    const checkDomainConditions = (domainValue) => {
        if (domainValue === '') { // Reset nếu input rỗng
            setDomainConditions({
                noSpaces: false,
                isShopNameLike: false,
                onlyLowercaseAndNumbers: false,
            });
            return;
        }

        const noSpacesMet = !/\s/.test(domainValue); // Kiểm tra không có khoảng trắng
        const isShopNameLikeMet = domainValue.length > 4; // Đơn giản là có ký tự
        const onlyLowercaseAndNumbersMet = /^[a-z0-9_]+$/.test(domainValue); // Chỉ chữ thường, số, và có thể _

        setDomainConditions({
            noSpaces: noSpacesMet,
            isShopNameLike: isShopNameLikeMet,
            onlyLowercaseAndNumbers: onlyLowercaseAndNumbersMet && noSpacesMet, // Phải thỏa mãn cả không có space
        });
    };

    useEffect(() => {
        if (props.user && props.user.status && props.user.status !== 200) {
            NotificatioErrController(props.user.data.responseText);
        }

        if (props.user && props.user.status && props.user.status === 200) {
            NotificatioSucController(props.user.data.responseText);

            setValues({ ...values, pinSuccessMessage: true });
        }
    }, [props.user]);

    const commonIconClass = "mr-2";
    const successIcon = "simple-icon-check text-success";
    const defaultIcon = "simple-icon-close text-muted"; // Giữ text-muted cho icon luôn cho đồng bộ    
    const errorIcon = "simple-icon-close text-danger"; // Icon cho lỗi
    const checkingIcon = "simple-icon-refresh text-info"; // Icon cho đang kiểm tra (ví dụ)


    return (
        <Row className='h-100'>
            <Colxx xxs='12' md='10' className='mx-auto my-auto auth-card-pad'>
                <Card className='auth-card' autoFocus={false}>
                    <div className='position-relative image-side '>
                        <p className='text-white h2'>ĐĂNG KÝ</p>
                        <p className='white mb-0'>
                            Điền đầy đủ thông tin và xác nhận email để hoàn tất đăng ký.{' '}
                            <br />
                        </p>
                    </div>
                    <div className='form-side'>
                        <a href='https://vmass.vn/' className='white'>
                            <span className='logo-single' />
                        </a>
                        <CardTitle className='mb-4'>
                            <IntlMessages id='user.register' />
                        </CardTitle>
                        <Form id="form-register">
                            <FormGroup className={'mb-4'}>
                                <Label className='has-float-label'>
                                    <Input
                                        autoFocus={true}
                                        onChange={onChangeHandleInput}
                                        type='text'
                                        name='fullname'
                                        id='fullname'
                                        defaultValue={values.name}
                                        />
                                    <IntlMessages id='user.fullname' />
                                </Label>
                                <span className="form-message"></span> 
                            </FormGroup>
                            <FormGroup className={'mb-4'}>
                                <Label className='has-float-label'>
                                    <Input
                                        onChange={onChangeHandleInput}
                                        type='tel'
                                        name='phone'
                                        id='phone'
                                        defaultValue={values.phone}
                                    />
                                    <IntlMessages id='user.phone' />
                                </Label>
                                <span className="form-message"></span> 
                            </FormGroup>
                            <FormGroup className={'mb-4'}>
                                <Label className='has-float-label'>
                                    <Input
                                        onChange={onChangeHandleInput}
                                        type='email'
                                        name='email'
                                        id='email'
                                        defaultValue={values.email}
                                    />
                                    <IntlMessages id='user.email' />
                                </Label>
                                <span className="form-message"></span> 
                            </FormGroup>
                            <Row>
                                <Colxx xxs='6' className='username'>
                                    <FormGroup className='mb-0'>
                                        <Label className='has-float-label mb-1'>
                                            <Input
                                                className="form-control text-end"
                                                // id='popover'
                                                onChange={onChangeHandleInput}
                                                type='text'
                                                name='domain'
                                                id='domain'
                                                defaultValue={values.domain}
                                            />
                                            <IntlMessages id='user.username' />
                                        </Label>
                                        <span className="form-message"></span> 
                                    </FormGroup>
                                </Colxx>
                                <span className='domain'>{`.${values.url}`}</span>
                            </Row>
                            <Row className="mt-2">
                                <Colxx xxs='12'>
                                    <div className={`text-small mt-1 ${domainConditions.noSpaces && domainConditions.onlyLowercaseAndNumbers ? 'text-success' : 'text-muted'}`}>
                                        <i className={`${commonIconClass} ${domainConditions.noSpaces && domainConditions.onlyLowercaseAndNumbers ? successIcon : defaultIcon}`} />
                                        Viết liền không dấu
                                    </div>
                                </Colxx>
                                <Colxx xxs='12'>
                                    <div className={`text-small mt-1 ${domainConditions.onlyLowercaseAndNumbers ? 'text-success' : 'text-muted'}`}>
                                        <i className={`${commonIconClass} ${domainConditions.onlyLowercaseAndNumbers ? successIcon : defaultIcon}`}/>
                                        Chỉ bao gồm chữ thường và số
                                    </div>
                                </Colxx>
                                <Colxx xxs='12'>
                                    <div className={`text-small mt-1 ${domainConditions.isShopNameLike ? 'text-success' : 'text-muted'}`}>
                                        <i className={`${commonIconClass} ${domainConditions.isShopNameLike ? successIcon : defaultIcon}`} />
                                        Là tên cửa hàng của bạn. Tối thiểu 5 ký tự
                                    </div>
                                </Colxx>
                                <Colxx xxs='12'>
                                    <div
                                        className={`text-small mt-1 ${
                                            (domainAvailability.status === 'available' && domainConditions.noSpaces && domainConditions.onlyLowercaseAndNumbers && domainConditions.isShopNameLike) ? 'text-success' :
                                            (domainAvailability.status === 'taken' || domainAvailability.status === 'error') ? 'text-danger' :
                                            domainAvailability.status === 'checking' ? 'text-info' : 'text-muted'
                                        }`}
                                    >
                                        <i className={`${commonIconClass} ${
                                            (domainAvailability.status === 'available' && domainConditions.noSpaces && domainConditions.onlyLowercaseAndNumbers && domainConditions.isShopNameLike) ? successIcon :
                                            (domainAvailability.status === 'taken' || domainAvailability.status === 'error') ? errorIcon :
                                            domainAvailability.status === 'checking' ? checkingIcon : defaultIcon
                                        }`} />
                                        {(domainConditions.noSpaces && domainConditions.onlyLowercaseAndNumbers && domainConditions.isShopNameLike) ? domainAvailability.message : values.domain !== '' ? 'Đang kiểm tra...' : 'Không trùng với tên của cửa hàng khác'}
                                    </div>
                                </Colxx>
                            </Row>
                            <FormGroup className={'mb-4'}>
                                <Label className='has-float-label mt-4'>
                                    <Input
                                        onChange={onChangeHandleInput}
                                        name='password'
                                        id='password'
                                        defaultValue={values.password}
                                        type='password'
                                    />
                                    <IntlMessages id='user.password' />
                                </Label>
                                <span className="form-message"></span> 
                            </FormGroup>
                            {values.pinSuccessMessage ? (
                                <p className='success-message'>
                                    Tài khoản của bạn đã được tạo, vui lòng kiểm
                                    tra Hộp thư đến hoặc hộp thư Spam để kích hoạt.
                                </p>
                            ) : null}
                            <div className='d-flex justify-content-end align-items-center'>
                                <Button
                                    color='primary'
                                    className='btn-shadow'
                                    size='lg'
                                    onClick={onUserRegister}
                                >
                                    <IntlMessages id='user.register-button' />
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Card>
            </Colxx>
        </Row>
    );
};
const mapStateToProps = ({ authUser }) => {
    const { user, loading } = authUser;
    return { user, loading };
};

export default connect(mapStateToProps, {
    registerUser,
})(Register);
